module.exports = __webpack_public_path__ + "static/media/Achievement125.fc09b9d7.jpg";